import angular from 'angular'

import { PaymentsResourceService } from './payments-resource.service'
import { CashModalController } from './cash-payment-modal/cash-payment-modal.controller'

// React Components
import { ReactTerminalStatusBarComponent } from './terminal-status/TerminalStatusBar'

angular
  .module('webregister.services')
  .service('paymentsResourceService', PaymentsResourceService)

angular
  .module('webregister.controllers')
  .controller('cashModalController', CashModalController)

angular
  .module('webregister.components')
  .component('reactTerminalStatusBar', ReactTerminalStatusBarComponent)
